module.exports = __webpack_public_path__ + "img/icon-lightbulb.6b20a78e.svg";